import { API_CONFIG } from '../config.js';

export default {
	getUserAPI: function() {
		return axios.get(API_CONFIG.API_URL + '/user_status');
	},

	putUserAPI: function(user) {
		console.log('axios putUserAPI', user);
		return axios.put(API_CONFIG.API_URL + '/user_status/' + user.uuid, user);
	}
};
